export default {
  src: 600114,
  vc: "100050",
  vn: "2.0.0",
};
